// src/components/FoundersSection.js

import React, { useState, useEffect, useRef } from 'react';
import './FoundersSection.css';
// 1. Import the specific icons you need
import { FaLinkedinIn, FaTwitter, FaGithub } from 'react-icons/fa';

// --- Data remains the same ---
const foundersData = [
  {
    id: 1,
    name: 'Gagan Velani',
    title: 'Founder',
    bio: 'Gagan is the visionary behind the company, driving our mission forward with a passion for innovation and user-centric design. Her leadership ensures we stay true to our core values.',
    imageUrl: '/images/Founder/GaganVelani.jpeg',
    socials: { linkedin: '#', twitter: '#' },
  },
  {
    id: 2,
    name: 'Disha Velani',
    title: 'CEO',
    bio: 'Disha spearheads our strategic growth, forging key partnerships and ensuring operational excellence. Her expertise in market dynamics is crucial to our expanding footprint.',
    imageUrl: '/images/Founder/DishaVelani.jpeg',
    socials: { linkedin: '#', twitter: '#' },
  },
  {
    id: 3,
    name: 'Samip Velani',
    title: 'Director',
    bio: 'Samip is the architectural mastermind of our technology. With over a decade of experience in scalable systems, he leads our engineering team to build a robust and future-proof platform.',
    imageUrl: '/images/Founder/SamipVelani.jpeg',
    socials: { linkedin: '#', github: '#' },
  }
];

// --- 2. REFACTORED SocialIcon COMPONENT ---
// This is now much cleaner and more maintainable.
const SocialIcon = ({ type }) => {
    // A map that links the social media name to its React Icon component
    const iconComponents = {
        linkedin: <FaLinkedinIn />,
        twitter: <FaTwitter />,
        github: <FaGithub />,
    };

    return (
        <a href={type.url} aria-label={type.name} target="_blank" rel="noopener noreferrer">
            {/* Render the correct icon based on the 'name' from the map */}
            {iconComponents[type.name] || null}
        </a>
    );
};

// --- No changes needed for the rest of the file ---

const useIntersectionObserver = (options) => {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const callbackFunction = (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
        }
    };
    useEffect(() => {
        const observer = new IntersectionObserver(callbackFunction, options);
        if (containerRef.current) observer.observe(containerRef.current);
        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, [containerRef, options, isVisible]);
    return [containerRef, isVisible];
};

const FounderCard = ({ founder, index }) => {
    const [cardRef, isVisible] = useIntersectionObserver({
        root: null,
        rootMargin: '0px',
        threshold: 0.2
    });

    const cardClasses = `
        founder-card 
        ${index % 2 !== 0 ? 'founder-card-reverse' : ''}
        ${isVisible ? 'is-visible' : ''}
    `;

    return (
        <article ref={cardRef} className={cardClasses}>
            <div className="founder-image-container">
                <img 
                    src={founder.imageUrl} 
                    alt={founder.name} 
                    loading="lazy" 
                    decoding="async" 
                />
            </div>
            <div className="founder-details">
                <h3>{founder.name}</h3>
                <p className="founder-title">{founder.title}</p>
                <p className="founder-bio">{founder.bio}</p>
                <div className="founder-socials">
                    {Object.entries(founder.socials).map(([name, url]) => (
                        <SocialIcon key={name} type={{ name, url }} />
                    ))}
                </div>
            </div>
        </article>
    );
};

const FoundersSection = () => {
    const firstFounder = foundersData[0];
    const otherFounders = foundersData.slice(1);

    return (
        <section className="founders-section">
            <div className="founders-header">
                <h1>Meet The Founders</h1>
            </div>
            <div className="founders-container">
                {firstFounder && (
                    <div className="founders-row-single">
                         <FounderCard
                            key={firstFounder.id}
                            founder={firstFounder}
                            index={0}
                        />
                    </div>
                )}
                {otherFounders.length > 0 && (
                    <div className="founders-row-multiple">
                        {otherFounders.map((founder, index) => (
                             <FounderCard
                                key={founder.id}
                                founder={founder}
                                index={index + 1}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default FoundersSection;